
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 15a2 2 0 110 4 2 2 0 010-4zm0 1a1 1 0 100 2 1 1 0 000-2zm-9-1a2 2 0 110 4 2 2 0 010-4zm0 1a1 1 0 100 2 1 1 0 000-2zM17 3H3.273L5.82 9H14a.994.994 0 00.8-.402l3-4h.001A1 1 0 0017 3zm-3 7H5.866L5.1 11.56 5 12a1 1 0 001 1h11v1H6a2 2 0 01-1.75-2.97l.72-1.474L1.338 1H0V0h2l.849 2H17a2 2 0 011.553 3.26l-2.914 3.886A1.998 1.998 0 0114 10z","fill":"#000"}})])
          )
        }
      }
    